<app-edit-contact
  [contact]="contact"
  [saving]="saving$ | async"
  (deleteContact)="deleteContact()"
  (saveContact)="saveContact($event)">
</app-edit-contact>
